import { useTranslations } from '@i18n/useLanguage'
import { IconButton } from '@app/components/core/button/IconButton'
import { faEllipsisVertical } from '@fortawesome/pro-solid-svg-icons'
import {
  DropdownMenu,
  type DropdownMenuItem,
} from '@app/components/core/dropdown/DropdownMenu'
import { INITIATIVE_USER_ROLES, InitiativeUserRole } from '@schema/initiative'
import { Action } from 'functions/app/dashboard/initiative/manage-participant'

export const SubMenu = ({
  role,
  onAction,
}: {
  role: InitiativeUserRole
  onAction: (action: Action) => void
}) => {
  const translations = useTranslations().app.dashboard.initiative.people

  const items: DropdownMenuItem[] = []

  if (isFollowerOrAdmin(role)) {
    items.push({
      id: 'makeMember',
      label: translations.makeMember,
      linkProps: {
        onClick: () => void onAction('makeMember'),
        textStyle: { textWrap: 'nowrap' },
      },
    })
  }

  if (isMemberOrAdmin(role)) {
    items.push({
      id: 'makeFollower',
      label: translations.makeFollower,
      linkProps: {
        onClick: () => void onAction('makeFollower'),
        textStyle: { textWrap: 'nowrap' },
      },
    })
  }

  if (role === INITIATIVE_USER_ROLES.member) {
    items.push({
      id: 'makeAdmin',
      label: translations.makeAdmin,
      linkProps: {
        onClick: () => void onAction('makeAdmin'),
        textStyle: { textWrap: 'nowrap' },
      },
    })
  }

  items.push({
    id: 'remove',
    label: translations.removeFromProject,
    linkProps: {
      onClick: () => void onAction('remove'),
      textStyle: {
        color: 'var(--brand-primary)',
        textWrap: 'nowrap',
      },
    },
  })

  return (
    <DropdownMenu items={items}>
      <IconButton
        variant="secondary"
        size="small"
        icon={faEllipsisVertical}
        onClick={() => {}}
      />
    </DropdownMenu>
  )
}

const isMemberOrAdmin = (role: InitiativeUserRole) =>
  role === INITIATIVE_USER_ROLES.member || role === INITIATIVE_USER_ROLES.admin

const isFollowerOrAdmin = (role: InitiativeUserRole) =>
  role === INITIATIVE_USER_ROLES.follower ||
  role === INITIATIVE_USER_ROLES.admin
